import React from "react"
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline"
import { Button } from "~/ui-rtk/components/ui/controls"
import { cn } from "~/ui-rtk/utils/tailwind-utils"
import useExportTableAccess from "~/ui-rtk/hooks/export-table-access"

export interface ExportButtonProps {
  onExport: () => void
  disabled?: boolean
  isLoading?: boolean
  variant?: "primary" | "secondary" | "outline"
  size?: "sm" | "md" | "lg"
  className?: string
  children?: React.ReactNode
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  onExport,
  disabled = false,
  isLoading = false,
  variant: _variant = "outline",
  size = "sm",
  className,
  children = "Export CSV",
}) => {
  const isExportTableAccess = useExportTableAccess()

  const handleClick = () => {
    if (!disabled && !isLoading) {
      onExport()
    }
  }

  if (!isExportTableAccess) {
    return null
  }

  return (
    <Button
      variant={{ variant: "solid", color: "blue" }}
      size={size}
      onClick={handleClick}
      disabled={disabled || isLoading}
      className={cn(
        "flex items-center gap-2 border border-system-blue-600 h-system-2xl px-system-lg py-system-sm rounded-system-md",
        "bg-system-blue-800 text-system-gray-300 hover:bg-system-blue-700",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        className,
      )}
    >
      {isLoading ? (
        <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        <ArrowDownTrayIcon className="w-4 h-4" />
      )}
      <span className="font-[Lato] text-base font-normal">{children}</span>
    </Button>
  )
}
